module.exports = __webpack_public_path__ + "img/2f_r_fukumitsu@2x.0527a912.png";